import {
  AppointmentQueueRow,
  DataUpdateError,
  DataUpdateSuccess,
  LegacyDataUpdatePayload,
} from './socket.types';

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isAppointmentQueueRows(payload: unknown): payload is AppointmentQueueRow[] {
  return Array.isArray(payload);
}

export function isLegacyRowsWrapper(payload: unknown): payload is { rows: AppointmentQueueRow[] } {
  if (!isObject(payload) || !('rows' in payload)) {
    return false;
  }

  const rows = payload.rows;
  return Array.isArray(rows);
}

export function isLegacyError(payload: unknown): payload is { error: string } {
  if (!isObject(payload) || !('error' in payload)) {
    return false;
  }

  return typeof payload.error === 'string';
}

export function isDataUpdateSuccess(payload: unknown): payload is DataUpdateSuccess {
  if (!isObject(payload)) {
    return false;
  }

  return (
    payload.ok === true
    && typeof payload.doctor === 'string'
    && Array.isArray(payload.data)
    && typeof payload.ts === 'string'
  );
}

export function isDataUpdateError(payload: unknown): payload is DataUpdateError {
  if (!isObject(payload)) {
    return false;
  }

  return (
    payload.ok === false
    && typeof payload.doctor === 'string'
    && typeof payload.error === 'string'
    && typeof payload.ts === 'string'
  );
}

export function extractRows(payload: LegacyDataUpdatePayload | unknown): AppointmentQueueRow[] | null {
  if (isAppointmentQueueRows(payload)) {
    return payload;
  }

  if (isLegacyRowsWrapper(payload)) {
    return payload.rows;
  }

  if (isDataUpdateSuccess(payload)) {
    return payload.data;
  }

  return null;
}
